import React from 'react';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function convertAndCombineDateTime(dateStr, timeStr) {
    const date = dayjs(dateStr);
    const time = dayjs(timeStr);

    return date.format('YYYY-MM-DD') + ' ' + time.format('HH:mm:ss');
}

export function extractDateTime(dateTimeStr) {
    const dateTime = dayjs(dateTimeStr).utc();
    const date = dateTime.format('YYYY-MM-DD');
    const time = dateTime.format('HH:mm:ss');
    return { date, time, dateTime };
}

export const getStatusOptionByOrder = (options, order) => {
    return options?.find((option) => option?.order === order);
};

export const boldText = (text) => {
    const regexPattern = /\*\*(.*?)\*\*/g;
    const parts = [];
    let lastIndex = 0;
    text.replace(regexPattern, (match, boldWord, index) => {
        parts.push(text.substring(lastIndex, index));
        parts.push(<strong key={index}>{boldWord}</strong>);
        lastIndex = index + match.length;
    });
    parts.push(text.substring(lastIndex));
    return <p>{parts}</p>;
};

export const safeJsonParse = (str) => {
    if (!str || typeof str !== 'string') return null;
    try {
        return JSON.parse(str);
    } catch {
        return null;
    }
};

export function parseAdjustedTime(input) {
    if (input === undefined || input === null) return 0;
    let s = String(input).trim().toLowerCase();
    if (!s || s === '--') return 0;

    // normalize dashes, multiple spaces, commas in decimals
    s = s
        .replace(/\u2212/g, '-')
        .replace(/\u2013|\u2014/g, '-')
        .replace(/\s+/g, ' ')
        .trim();

    // Colon format (e.g. "2:30")
    if (s.includes(':')) {
        const parts = s.split(':').map((p) => p.trim());
        const hours = parseInt(parts[0].replace(/\D/g, ''), 10) || 0;
        const minutes = parseInt((parts[1] || '').replace(/\D/g, ''), 10) || 0;
        return Math.max(0, hours * 60 + minutes);
    }

    // Tokenize for forms like "2h3m", "2 h 3 m", "2.5h", "30m"
    const tokenRegex = /(-?\d+(?:[.,]\d+)?)(?:\s*)(h|hr|hour|hours|m|min|mins|minute|minutes)?/gi;
    let hours = 0;
    let minutes = 0;
    let foundUnit = false;
    let anyMatch = false;

    for (const match of s.matchAll(tokenRegex)) {
        const rawNum = (match[1] || '').replace(',', '.');
        const unit = (match[2] || '').toLowerCase();
        const num = parseFloat(rawNum) || 0;
        // If there was no numeric capture (shouldn't happen), skip
        if (!match[1]) continue;
        anyMatch = true;

        if (unit) {
            foundUnit = true;
            if (unit.startsWith('h')) {
                hours += num;
            } else {
                minutes += Math.round(num);
            }
        } else {
            // bare number without unit -> treat as minutes for now
            minutes += Math.round(num);
        }
    }

    if (!anyMatch) return 0;

    if (foundUnit) {
        return Math.max(0, Math.round(hours * 60) + minutes);
    }

    // If no unit tokens found, and the whole string is a single number, treat as minutes
    const bare = s.match(/^(-?\d+(?:[.,]\d+)?)$/);
    if (bare) {
        return Math.max(0, Math.round(parseFloat(bare[1].replace(',', '.')) || 0));
    }

    // fallback: extract first numeric token as minutes
    const anyNum = s.match(/(-?\d+(?:[.,]\d+)?)/);
    if (anyNum) return Math.max(0, Math.round(parseFloat(anyNum[1].replace(',', '.')) || 0));

    return 0;
}

export const formatTooltipText = (text) => {
    if (!text) return '';

    const lines = text.split(/\\n/);

    return (
        <>
            {lines.map((line, lineIndex) => {
                const parts = line.split(/\*\*(.*?)\*\*/);
                return (
                    <React.Fragment key={lineIndex}>
                        {parts.map((part, index) => {
                            return index % 2 === 1 ? <b key={index}>{part}</b> : <span key={index}>{part}</span>;
                        })}
                        {lineIndex < lines.length - 1 && <br />}
                    </React.Fragment>
                );
            })}
        </>
    );
};
